<template>
    <div class="mx-auto text-center pt-12 w-full">
        <h1 class="h1 mb-4">Categories</h1>
        <p class="text-xl">Which items are you interested in?</p>
        <p class="text-sm sm:mb-4 mt-2 mb-4">(Select all that apply)</p>
        <form method="post" :action="route('categories.store', type)" class="justify-center">
            <input type="hidden" name="_token" :value="csrf_token" />
            <div class="mx-auto flex justify-center">
                <div class="flex flex-wrap max-w-2xl font-semibold w-full justify-center">
                    <div v-for="parent in categories" class="font-bold mb-12 flex flex-wrap w-full">

                        <input type="checkbox" name="categories[]" class="hidden" :value="parent.parent.id"
                               v-model="selected[parent.parent.id]"  />
                        <label :value="parent.parent.id" @click="parentSelected(parent)"
                               class="w-full text-xl px-8 select-none cursor-pointer flex items-center justify-center h-16 border mb-4 "
                               :class="selected[parent.parent.id] ? 'fw-btn fw-btn-green' : 'fw-btn bg-red-500'">
                            {{ parent.parent.name }}
                        </label>

                        <div v-for="category in parent.categories" class="block w-full">
                            <input type="checkbox" name="categories[]" class="hidden" :value="category.category.id"
                                v-model="selected[category.category.id]" />
                            <label :value="category.category.id" @click="categorySelected(category)"
                                class="w-full px-8 select-none cursor-pointer flex items-center justify-center h-16 border font-normal"
                                :class="selected[category.category.id] ? 'fw-btn fw-btn-green' : 'fw-btn bg-red-500'">
                                {{ category.category.name }} ( <i v-if="selected[category.category.id]" class="fa fa-check" /><i v-else class="fa fa-x"></i> )
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap mt-8 sm:max-w-sm mx-auto">
                <button class="n az fw-btn fw-btn-green w-full" type="submit" style="outline: none;">Next
                </button>
            </div>
        </form>
    </div>
</template>
<script>
    export default {
        mounted() {

            Object.keys(this.categories).forEach(key => {

                let parent = this.categories[key];

                this.selected[parent.parent.id] = parent.selected;

                let categories = parent.categories;

                categories.forEach((category) => {

                    if (category.selected) {
                        this.selected[category.category.id] = true;
                        this.selected[parent.parent.id] = true;
                    }



                });


            });

            // this.categories.forEach((category) => {
            //
            //     let record = category.category;
            //
            //     if (record.selected) {
            //         this.selected[record.category.id] = true;
            //     }
            // });
        },
        props: {
            categories: {
                required: true,
                type: Object
            },
            type: {
                required:true,
                type: String
            }
        },
        data() {
            return {
                selected: {},
                csrf_token: window.CSRF
            }
        },
        methods: {
            categorySelected(category) {
                this.selected[category.category.id] = !this.selected[category.category.id];
                this.selected[category.category.parent_id] = true;
            },
            parentSelected(parent) {
                let result = !this.selected[parent.parent.id];
                this.selected[parent.parent.id] = result;
                let categories = parent.categories;
                categories.forEach((category) => {
                    this.selected[category.category.id] = result;
                });
            }
        }
    }

</script>
